<div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="card">
      <div class="materialTableHeader">
        <div class="left">
          <ul class="header-buttons-left ms-0">
            <li class="tbl-search-box">
              <label><i class="material-icons search-icon">search</i></label>
              <input
                #filter
                aria-autocomplete="none"
                aria-label="Search box" autocomplete="nope" class="browser-default search-field" placeholder="BUSCAR"
                type="text">
            </li>
          </ul>
        </div>
      </div>
      <div class="body overflow-auto">
        <div class="responsive_table">
          <table [dataSource]="dataSource" class="mat-cell advance-table" mat-table matSort>

            <ng-container matColumnDef="idEntidad">
              <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.idEntidad}}">{{ row.idEntidad }}</mat-cell>
            </ng-container>


            <ng-container matColumnDef="nombre">
              <mat-header-cell *matHeaderCellDef mat-sort-header>ENTIDAD</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.nombre}}"><span
                class="mobile-label">Nombre Entidad:</span>{{ row.nombre }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="abreviatura">
              <mat-header-cell *matHeaderCellDef mat-sort-header>ABREVIATURA</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.abreviatura}}"><span
                class="mobile-label">Abreviatura:</span>{{ row.abreviatura }}
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
            </mat-row>
          </table>
          <!-- Loading spinner -->
          @if (data?.isTblLoading) {
            <div class="tbl-spinner">
              <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
              </mat-progress-spinner>
            </div>
          }
          @if (!data?.isTblLoading) {
            <div class="no-results" [style.display]="dataSource.renderedData.length === 0 ? '' : 'none'">
              Sin resultados
            </div>
          }
          <mat-paginator [length]="dataSource.filteredData.length" [pageIndex]="0" [pageSizeOptions]="[5, 10, 25, 100]"
                         [pageSize]="10">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
